import { RevealBlock } from "./motion";
import { Plane, BadgeCheck, Settings, Radio } from "lucide-react";

const ITEMS = [
  { icon: Plane,      t: "Traveller-first curation", d: "A focused range organised around real airport needs." },
  { icon: BadgeCheck, t: "Compliance-led range",     d: "Product suitability reviewed for each agreed location." },
  { icon: Settings,   t: "Fully managed service",    d: "Stocking, monitoring and servicing handled by MinisRus." },
  { icon: Radio,      t: "Remote & cashless",         d: "Live machine visibility with fast tap-to-pay checkout." },
];

export default function TrustBar() {
  return (
    <section className="relative bg-ink py-10 md:py-14 border-t border-white/8" data-testid="trust-bar">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <RevealBlock key={it.t} delay={i * 0.06} y={20} className="flex items-start gap-4" data-testid={`trust-${it.t.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}>
              <div className="shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full border border-orange/70 flex items-center justify-center">
                <Icon size={20} strokeWidth={1.6} className="text-orange" />
              </div>
              <div>
                <p className="text-bone text-[15px] font-semibold leading-tight">{it.t}</p>
                <p className="text-bone/60 text-xs md:text-[13px] mt-1.5 leading-snug">{it.d}</p>
              </div>
            </RevealBlock>
          );
        })}
      </div>
    </section>
  );
}
